import { TefComs } from '@mfe-4cs/types/typings';

export const isUuid = (uuid: string): boolean => {
  const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return pattern.test(uuid);
};

export const isReference = (object: unknown): object is TefComs.Reference => Object.prototype.hasOwnProperty.call(object, 'type')
  && Object.prototype.hasOwnProperty.call(object, 'source')
  && Object.prototype.hasOwnProperty.call(object, 'id');
